<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Teachers</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <el-tooltip class="item" effect="dark" content="Add Teacher/Admin" placement="top">
                                <n-button
                                    @click.native="openModal()"
                                    class="view ml-2"
                                    type="primary"
                                    size="sm"
                                    round
                                    icon
                                    simple
                                >
                                    <i class="fa fa-plus"></i>
                                </n-button>
                            </el-tooltip>

                            <n-button
                                @click.native="openUploadModal()"
                                class="view ml-2"
                                type="warning"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-upload"></i>
                            </n-button>

                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="180" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <el-tooltip class="item" effect="dark" content="View" placement="top">
                                    <n-button
                                        @click.native="handleView(props.$index, props.row)"
                                        class="view"
                                        type="primary"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-eye"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                    <n-button
                                        @click.native="handleEdit(props.$index, props.row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                    <n-button
                                        @click.native="handleDelete(props.$index, props.row)"
                                        class="remove"
                                        type="danger"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-times"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Reset Password" placement="top">
                                    <n-button
                                        @click.native="handleReset(props.$index, props.row)"
                                        class="reset"
                                        type="success"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-refresh"></i>
                                    </n-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Add New Teacher</h4>
            <form>
                <div class="row">
                    <div class="col-4">
                        <fg-input
                            type="text"
                            required
                            name="role"
                            label="Roles"
                            v-validate="modelValidations.role"
                            :error="getError('role')"
                            
                            v-model="model.role">
                            <el-select class="select-primary" placeholder="Select Roles" v-model="model.role" multiple collapse-tags>
                                <el-option v-for="(option, index) in roles" class="select-primary" :value="option.slug" :label="option.title" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-4">
                        <fg-input
                            type="text"
                            required
                            name="designation"
                            label="Designation"
                            v-validate="modelValidations.designation"
                            :error="getError('designation')"
                            v-model="model.designation">
                            <el-select class="select-primary" placeholder="Select Designation" v-model="model.designation">
                                <el-option v-for="(option, index) in designations" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-4">
                        <fg-input
                            type="text"
                            required
                            name="salutation"
                            label="Salutation"
                            v-validate="modelValidations.salutation"
                            :error="getError('salutation')"
                            v-model="model.salutation">
                            <el-select class="select-primary" placeholder="Select Salutation" v-model="model.salutation">
                                <el-option v-for="(option, index) in salutations" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="deanery"
                            label="Deanery"
                            v-validate="modelValidations.deanery"
                            :error="getError('deanery')"
                            v-model="model.deanery">
                            <el-select class="select-primary" placeholder="Select Deanery" v-model="model.deanery">
                                <el-option v-for="(option, index) in deaneries" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="department"
                            label="Department"
                            v-validate="modelValidations.department"
                            :error="getError('department')"
                            v-model="model.department">
                            <el-select class="select-primary" placeholder="Select Department" v-model="model.department">
                                <el-option v-for="(option, index) in departments" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="register_no"
                            label="Register Number"
                            v-validate="modelValidations.register_no"
                            :error="getError('register_no')"
                            v-model="model.register_no">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="email"
                            name="mail"
                            label="Email"
                            v-validate="modelValidations.mail"
                            :error="getError('mail')"
                            v-model="model.mail">
                        </fg-input>
                    </div>
                    <div class="col-6" v-if="model.password">
                        <fg-input
                            type="password"
                            name="password"
                            label="Password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            v-model="model.password">
                        </fg-input>
                    </div>
                    <div :class="{ 'col-6': model.password, 'col-12': !model.password }">
                        <fg-input
                            type="text"
                            name="name"
                            label="Name"
                            v-validate="modelValidations.name"
                            :error="getError('name')"
                            v-model="model.name">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="qualification"
                            label="Qualification"
                            v-validate="modelValidations.qualification"
                            :error="getError('qualification')"
                            v-model="model.qualification">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="blood_group"
                            label="Blood Group"
                            v-validate="modelValidations.blood_group"
                            :error="getError('blood_group')"
                            v-model="model.blood_group">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            required
                            type="date"
                            name="doj"
                            label="Date of Joining"
                            v-validate="modelValidations.doj"
                            :error="getError('doj')"
                            v-model="model.doj">
                            <el-date-picker 
                                v-model="model.doj" 
                                type="date" 
                                placeholder="Date of Joining">
                            </el-date-picker>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            required
                            type="date"
                            name="dob"
                            label="Date of Birth"
                            v-validate="modelValidations.dob"
                            :error="getError('dob')"
                            v-model="model.dob">
                            <el-date-picker 
                                v-model="model.dob" 
                                type="date" 
                                placeholder="Date of Birth">
                            </el-date-picker>
                        </fg-input>
                    </div>
                    
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate()" type="primary">Save Teacher</n-button>
            </template>
        </modal>

        <modal :show.sync="modals.upload" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Upload New Teachers</h4>
            <form>
                <div class="row">

                    <div class="col-12">
                        <el-upload
                            drag
                            ref="upload"
                            name="teachers"
                            class="upload-demo"
                            :limit="1"
                            :action="uploadURL"
                            :multiple="false"
                            :auto-upload="true"
                            :show-file-list="false"
                            :http-request="handleFileUpload"
                            :on-exceed="handleFileExceed"
                            :on-success="handleFileSuccess"
                            :on-error="handleFileError"
                            :on-progress="handleFileProgress">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                                <div class="el-upload__tip" slot="tip">csv file with a size less than 5Mb | <a target="_blank" download href="/templates/teachers-upload-template.csv">Download Template CSV</a></div>

                        </el-upload>
                        
                        <el-progress 
                            v-if="fileUploadProgress.total > 0" 
                            :text-inside="true" :stroke-width="15"
                            :percentage="Math.round(fileUploadProgress.percent)" 
                            :status="(fileUploadProgress.percent == 100) ? 'success' : ''">
                        </el-progress>
                    </div>
                    
                </div>
            </form>
            <template slot="footer">
                <p class="status" :class="uploadStatusClass">{{ uploadStatus }}</p>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Transfer, DatePicker, Progress, Upload } from "element-ui";
import { Pagination as NPagination, Modal } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Transfer.name]: Transfer,
        [DatePicker.name]: DatePicker,
        [Progress.name]: Progress,
        [Upload.name]: Upload,
        Modal
    },
    computed: {
        ...mapGetters({
            tableData: 'getTeachers',
            departments: 'getDepartments',
            deaneries: 'getDeaneries',
            courses: 'getCourses',
            roles: 'getRoles',
            designations: 'getDesignations',
            salutations: 'getSalutations',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        },
        uploadURL(){
            return `${process.env.VUE_APP_ADMIN_URL}/users/teachers/csv`
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "register", "name", "email", "department", "deanery", "qualification", "doj", "dob", "designation", "salutation" ],
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "register_no",
                    label: "Reg #",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: true,
                },
                {
                    prop: "name",
                    label: "Name",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        return `${row.salutation}. ${cellValue}`; 
                    }
                },
                {
                    prop: "designation",
                    label: "Designation",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "mail",
                    label: "Email",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "qualification",
                    label: "Qualification",
                    minWidth: 250,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "department",
                    label: "Department",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "deanery",
                    label: "Deanery",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "doj",
                    label: "DOJ",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                {
                    prop: "dob",
                    label: "DOB",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                },
                
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false,
                upload: false
            },
            model: {
                _id: null,
                role: [],
                mail: '',
                password: 'secret',
                user_type: 'teacher',
                register_no: '',
                name: '',
                department: null,
                deanery: null,
                qualification: '',
                doj: new Date(),
                dob: new Date(),
                blood_group: 'A+',
                designation: null,
                salutation: null

            },
            modelValidations: {
                role: {
                    required: true,
                },
                mail: {
                    email: true,
                    required: true,
                },
                password: {
                    required: true,
                    min: 6
                },
                name: {
                    required: true,
                },
                register_no: {
                    required: true,
                },
                department: {
                    required: true,
                },
                deanery: {
                    required: true,
                },
                doj: {
                    required: true
                },
                dob: {
                    required: true
                },
                qualification: {
                    required: true
                },
                designation: {
                    required: true
                },
                salutation: {
                    required: true
                },
                blood_group: {
                    required: false
                }
            },
            datePickerOptions: {
                shortcuts: []
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
            uploadStatusClass: 'text-info',
            uploadStatus: '',
            fileUploadProgress: {
                percent: 0,
                loaded: 0,
                total: 0
            }
        };
    },
    methods: {
        handleFileBefore(file) {
            const isCSV = file.type === 'text/csv';
            const isLt5M = file.size / 1024 / 1024 < 5;

            this.uploadStatusClass = 'text-info'
            this.uploadStatus = ''
            this.fileUploadProgress =  {
                percent: 0,
                loaded: 0,
                total: 0
            }

            if (!isCSV) {
                this.uploadStatusClass = 'text-danger'
                this.uploadStatus = 'File must be CSV format!'
            }
            if (!isLt5M) {
                this.uploadStatusClass = 'text-danger'
                this.uploadStatus = 'File size can not exceed 5MB!'
            }
            return isCSV && isLt5M;
        },
        // not used
        handleFileUpload() {
            const file = this.$refs.upload.uploadFiles[0]
            let formData = new FormData()
            formData.append('teachers', file.raw)
            this.$store.dispatch('uploadCSV', {type: 'teachers', payload: formData})
        },
        handleFileSuccess(response, file, fileList) {
            // handleFileSuccess
            if(response.status == 200){
                this.uploadStatusClass = 'text-success'
                this.uploadStatus = 'File uploaded'
            }
        },
        handleFileError(err, file, fileList) {
            // handleFileError
            this.uploadStatusClass = 'text-danger'
            this.uploadStatus = 'error'
        },
        handleFileProgress(event, file, fileList) {
            // handleFileProgress
            this.fileUploadProgress = event
            this.uploadStatusClass = 'text-infp'
            this.uploadStatus = 'progressing'
        },
        handleFileExceed(files, fileList) {
            // handleFileExceed
            this.uploadStatusClass = 'text-warning'
            this.uploadStatus = 'Files upload limit exceeded!'
        },

        handleView(index, row) {
            // handleView
        },
        handleEdit(index, row) {

            this.model = Object.assign({}, row);
            this.scope = 'edit'
            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        handleReset(index, row) {
            swal({
                title: "Are you sure?",
                text: `Password will be reset to the register number.`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Reset Password!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.$store.dispatch('resetPassword', {mail: row.mail})
                }
            });
        },
        deleteRow(row) {
            this.$store.dispatch('deleteTeacher', row.user_id)
        },
        openModal(){

            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });

            this.model.role = []
            this.model.mail = ''
            this.model.password = 'secret'
            this.model.user_type = 'teacher'
            this.model.register_no = ''
            this.model.name = ''
            this.model.qualification = ''
            this.model.doj = new Date()
            this.model.doj = new Date()
            this.model.salutation = ''
            this.model.designation = ''
            this.model.department = ''
            this.model.deanery = ''
            this.model.blood_group = ''

            this.scope = 'add'
            this.modals.add = true
        },
        openUploadModal(){
            this.scope = 'upload'
            this.modals.upload = true
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){
                    
                    switch(this.scope){
                        case 'add'  : this.$store.dispatch('createTeacher', this.model); break;
                        case 'edit' : this.$store.dispatch('updateTeacher', this.model); break;
                    }
                    
                    this.modals.add = false
                }
            });
        },
        downloadTemplate(){
            // @TODO: download templat efile link.
            console.log('Download File');
            
        },
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getTeachers');
        this.$store.dispatch('getDepartments');
        this.$store.dispatch('getDeaneries');
        this.$store.dispatch('getCourses');
        this.$store.dispatch('getRoles');
        this.$store.dispatch('getDesignations');
        this.$store.dispatch('getSalutations');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-demo{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

